module.exports = __webpack_public_path__ + "img/digital-chart_ar.e1aad91a.png";